(function initMobileNav(){
  if (window.__mobileMenuUnified__) return;
  function start(){
    if (window.__mobileMenuUnified__) return;
    window.__mobileMenuUnified__ = true;
    function qs(sel, root){ return (root||document).querySelector(sel); }
    const html = document.documentElement;
    const body = document.body;
    const btn = qs('[data-action="toggle-mobile-nav"]');
    const nav = qs('#mobile-nav');
    if (!btn || !nav) return;
    if (btn.tagName === 'BUTTON' && btn.type !== 'button') { btn.type = 'button'; }
    if (btn.tagName === 'A') {
      var href = btn.getAttribute('href') || '';
      if (href === '' || href === '#' || href === location.href || href === location.pathname) {
        btn.setAttribute('data-orig-href', href);
        btn.setAttribute('href', 'javascript:void(0)');
      }
    }
    function findGloboTrigger(){
      return qs('.globo-mega-menu [aria-expanded], .globo-mega-menu .gm-navbar-toggle, .globo-mega-menu .gm-toggle, .globo-mega-menu [data-gm-toggle], .globo-mega-menu [data-toggle]');
    }
    function openGlobo(){
      const trg = findGloboTrigger();
      if (trg && trg.getAttribute && trg.getAttribute('aria-expanded') !== 'true') trg.click();
    }
    function closeGlobo(){
      const trg = qs('.globo-mega-menu [aria-expanded="true"]');
      if (trg) trg.click();
    }
    let backdrop = qs('#mobile-nav-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('button');
      backdrop.id = 'mobile-nav-backdrop';
      backdrop.type = 'button';
      backdrop.setAttribute('aria-label', 'Menü schließen');
      backdrop.setAttribute('data-no-instant','');
      body.appendChild(backdrop);
    }
    let removedInstantIntensity = null;
    const isOpen = () => html.classList.contains('mobile-nav-open');
    function pauseInstant(){
      if (body.hasAttribute('data-instant-intensity')) {
        removedInstantIntensity = body.getAttribute('data-instant-intensity');
        body.removeAttribute('data-instant-intensity');
      }
    }
    function resumeInstant(){
      if (removedInstantIntensity !== null) {
        body.setAttribute('data-instant-intensity', removedInstantIntensity);
        removedInstantIntensity = null;
      }
    }
    const navFreeze = { active:false, assign:null, replace:null, reload:null, push:null, rep:null };
    function enableNavFreeze(){
      if (navFreeze.active) return;
      navFreeze.active = true;
      try {
        navFreeze.assign  = window.location.assign.bind(window.location);
        navFreeze.replace = window.location.replace.bind(window.location);
        navFreeze.reload  = window.location.reload ? window.location.reload.bind(window.location) : null;
        navFreeze.push    = history.pushState.bind(history);
        navFreeze.rep     = history.replaceState.bind(history);
        window.location.assign = function(url){};
        window.location.replace = function(url){};
        if (navFreeze.reload) window.location.reload = function(){};
        history.pushState = function(state,title,url){};
        history.replaceState = function(state,title,url){};
      } catch(_) {}
    }
    function disableNavFreeze(){
      if (!navFreeze.active) return;
      navFreeze.active = false;
      try {
        if (navFreeze.assign)  window.location.assign  = navFreeze.assign;
        if (navFreeze.replace) window.location.replace = navFreeze.replace;
        if (navFreeze.reload)  window.location.reload  = navFreeze.reload;
        if (navFreeze.push)    history.pushState       = navFreeze.push;
        if (navFreeze.rep)     history.replaceState    = navFreeze.rep;
      } catch(_) {}
    }
    function openMenu(){
      html.classList.add('mobile-nav-open');
      btn.setAttribute('aria-expanded','true');
      nav.setAttribute('aria-hidden','false');
      openGlobo();
      pauseInstant();
      enableNavFreeze();
    }
    function closeMenu(){
      html.classList.remove('mobile-nav-open');
      btn.setAttribute('aria-expanded','false');
      nav.setAttribute('aria-hidden','true');
      closeGlobo();
      disableNavFreeze();
      resumeInstant();
    }
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      isOpen() ? closeMenu() : openMenu();
    }, { passive:false });
    backdrop.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      closeMenu();
    }, { passive:false });
    function killOutside(e){
      if (!isOpen()) return;
      const insideMenu = nav.contains(e.target) || btn.contains(e.target) || e.target.closest('.globo-mega-menu');
      if (insideMenu) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeMenu();
    }
    ['touchstart','touchend','pointerdown','pointerup','click'].forEach(evt=>{
      document.addEventListener(evt, killOutside, { capture:true, passive:false });
    });
    document.addEventListener('keydown', function(e){
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); closeMenu(); }
    }, { capture:true });
    let syncing = false;
    const mo = new MutationObserver(() => {
      if (syncing) return;
      syncing = true;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded && !isOpen()) openMenu();
      if (!expanded && isOpen()) closeMenu();
      syncing = false;
    });
    mo.observe(btn, { attributes:true, attributeFilter:['aria-expanded'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once:true });
  } else {
    start();
  }
})();
